import $ from 'jquery';

require('fg-frontend/plugins/jquery.universal-pagination');
require('fg-frontend/plugins/jquery.radioSelectTab');
// require('components/jquery/jquery.webslider');
// require('components/highlight/index');
require('@fancyapps/fancybox');

// export to window
window.$ = $;
window.jQuery = $;
window.isTouchDevice = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));

var projectConfig = window.projectConfig || {};

// universal preloader
import Preloader from 'fg-frontend/plugins/universal-preloader/preloader';

const universalPreloader = new Preloader();


// var svg4everybody = require('svg4everybody/dist/svg4everybody');
// svg4everybody();


/**
 * stage list pagination
 *
 */
$(document).on('STAGE_PAGINATION_ACTIVATE', function () {
  $('.js_pagination-stage').each(function (index, item) {
    var $page = $(item);

    $page.universalPagination({
      listSelector: '.js_psList',
      itemSelector: '.js_psItem',
      lang: projectConfig.lang,
      nextClass: 'btn btn--pagination',
      nextWrapperClass: 'buttons buttons--center',
      autoPreloadHistory: false,
      listTopOffset: 15,
      paginationSelector: '.js_pagination-stage',
      wrapperClass: 'pagination__wrapper',
    });
  });
}).on('ajaxComplete', function () {
  $(document).trigger('STAGE_PAGINATION_ACTIVATE');
});
$(document).trigger('STAGE_PAGINATION_ACTIVATE');

//show on scroll

function isElementInViewport(el) {
  var top = el.offsetTop;
  var left = el.offsetLeft;
  var width = el.offsetWidth;
  var height = el.offsetHeight;

  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
    left += el.offsetLeft;
  }

  return (
    top < (window.pageYOffset + window.innerHeight) &&
    left < (window.pageXOffset + window.innerWidth) &&
    (top + height) > window.pageYOffset &&
    (left + width) > window.pageXOffset
  );
}

function checkElementInViewportAndSetClass(time) {
  $('.js_animate').each(function () {
    if (isElementInViewport(this) === true) {
      var $t = $(this);
      window.setTimeout(function () {
        $t.addClass('show');
      }, time);
    }
  });
}

$(window).scroll(function () {
  checkElementInViewportAndSetClass(300);
});
checkElementInViewportAndSetClass(0);

import Masonry from 'masonry-layout';

if (document.getElementsByClassName('masonry-grid').length > 0) {
  new Masonry('.masonry-grid', {
    itemSelector: '.masonry-grid__item',
  });
}

import Swiper from 'swiper';

var mainSwiper = new Swiper('.main-swiper__container', {
  navigation: {
    nextEl: '.main-swiper__next',
    prevEl: '.main-swiper__prev',
  },
  effect: 'fade',
  speed: 600,
  simulateTouch: false,
});

mainSwiper.on('slideChange', function () {
  $('.main-swiper__pagination-item').each(function () {
    $(this).removeClass('active');
    if ($(this).index() === mainSwiper.activeIndex) {
      $(this).addClass('active');
    }
  });
});

$('.main-swiper__pagination-item').on('click', function () {
  mainSwiper.slideTo($(this).index());
});


//promo animation slider

var promoSlider = new Swiper('.promo-slider__container', {
  effect: 'fade',
  speed: 500,
  autoplay: {
    delay: 6000,
  },
  //simulateTouch: false
});

promoSlider.on('slideChange', function () {
  if (promoSlider.activeIndex === 1) {
    $('.promo-slider__phone').addClass('animate');
    $('.promo-slider__laptop').removeClass('animate');
  } else {
    $('.promo-slider__phone').removeClass('animate');
    $('.promo-slider__laptop').addClass('animate');
  }
})


//start animation when elements are loaded

$(function () {

  /*
  if ($('#promo__img-1').length) {

    var images = document.body.getElementsByClassName('promo__img');

    for (var i = 0; i < images.length; i++) {
            images[i].addEventListener('load', function(){
        alert('test');
      })
    }
    }
  */

  if ($('.promo__img').length > 0) {
    promoSlider.autoplay.stop();
    var interval = setInterval(function () {
      var images = document.body.getElementsByClassName('promo__img');
      var length = images.length;
      var counter = 0;
      for (var i = 0; i < length; i++) {
        if (images[i].complete) {
          counter++;
        }
      }
      if (counter === length) {
        $('.promo-slider, .promo-slider__laptop').addClass('animate');
        promoSlider.autoplay.start();
        clearInterval(interval);
      }
    }, 100);
  }
});

$(function () {
  var element = document.getElementById("schema__cloud-img");
  if (element != null) {

    if (element.complete) {
      $('.schema').addClass('animate');
    } else {
      element.addEventListener('load', () => {
        $('.schema').addClass('animate');
      });
    }
  }
});

//mobile menu
$('.header__submenu-opener').on('click', function () {
  if ($(this).hasClass('header__submenu-opener--opened')) {
    $(this).parent().find('.header__submenu').stop().slideUp(200);
    $(this).removeClass('header__submenu-opener--opened');
  } else {
    $(this).parent().find('.header__submenu').stop().slideDown(200);
    $(this).addClass('header__submenu-opener--opened');
  }
});

$('.header__hamburger, .header__menu-backdrop, .header__close-menu').on('click', function () {
  $('.header').toggleClass('header--menu-opened');
  $('.header__menu-backdrop').toggleClass('header__menu-backdrop--menu-opened');
  $('body').toggleClass('overflow-hidden');
});

//scroll to
$('.scroll-to').on('click', function (e) {
  e.preventDefault();
  scrollTo($($(this).attr('href')));
});

function scrollTo(el) {
  var windowWidth = $(window).width();
  let header = 0;
  if (windowWidth < 768) {
    header = $('.header').outerHeight();
  }
  let top = el.offset().top - header;
  $('html, body').stop().animate({
    scrollTop: top
  }, 800);
}

$('body').on('click', '.js_openForm', (event) => {
  event.preventDefault();
  $.fancybox.open({
    src: '/qf/cs/ramjet/edeeLead/contactFormIframe',
    type: 'iframe',
    opts: {
      autoSize: false,
      css: {
        width: '600px',
      },
    },
  });
});

$('body').on('click', '.js_esp-custom-close', (event) => {
  event.preventDefault();
  let et = $('.esp');
	if (et.hasClass('esp__target--opened')) {
		et.removeClass('esp__target--opened esp-target-opened');
	}
});

$('body').on('click', '.js_openTableRows', (event) => {
  const el = $(event.target).parents('.js_openTableRows').first();

  el.toggleClass('tableRow--highlighted');

  let subEl = nextEle(el);
  for (var i = 0; i < 100; i++) {
    if (subEl.hasClass('js_openTableRows-item')) {
      subEl.toggleClass('tableRow--hidden');
    } else {
      break;
    }
    subEl = nextEle(subEl);
  }
});

/* FancyBox */
$('[data-fancybox]').fancybox({
  youtube: {
    controls: 0,
    showinfo: 0,
  },
});

function nextEle(el) {
  return el.next();
}

if ($('.js_indexShowAllItem').length) {
  $('.js_indexShowAllItem').on('click', function () {
    $('.list-index__item').removeClass('sr-only');
    $('.list-index__buttons').remove();
  });
}

/*
 * !!!NECHAT NA KONCI web.js!!!
 * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
 * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
 * Inline JavaScript musí být vnořen do následujícího kusu kódu
 *
 * $(function(){
 *     //inline JavaScript
 * });
 *
 * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
 * předpokládá se tedy, že na webu bude použito jQuery
 *
 * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
 * */
if (window.q) {
  window.q.forEach((f) => {
    $(f);
  });
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js